import { render, staticRenderFns } from "./UserBestellungen.vue?vue&type=template&id=4707fea0&"
import script from "./UserBestellungen.vue?vue&type=script&lang=js&"
export * from "./UserBestellungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports